import styled from 'styled-components';

const I = styled.i`
	font-size: 2.5rem;

	display: flex;
	align-items: center;
	justify-content: center;
`;

export default I;